import { render } from "./AdminNavbar.vue?vue&type=template&id=3a6b3dd4&scoped=true"
const script = {}

import "./AdminNavbar.vue?vue&type=style&index=0&id=3a6b3dd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6b3dd4"]])

export default __exports__